import type { ITask } from '../data/types';

interface IConnectionsProps {
  tasks: ITask[];
  visibleIds: Set<string>;
}

const NODE_W = 168;
const NODE_H = 92;

const STROKE: Record<ITask['status'], string> = {
  done: 'rgba(62, 207, 142, 0.34)',
  in_progress: 'rgba(245, 165, 36, 0.4)',
  todo: 'rgba(255, 255, 255, 0.12)',
};

const DOT: Record<ITask['status'], string> = {
  done: 'rgba(62, 207, 142, 0.6)',
  in_progress: 'rgba(245, 165, 36, 0.65)',
  todo: 'rgba(255, 255, 255, 0.22)',
};

export const Connections = ({ tasks, visibleIds }: IConnectionsProps) => {
  const taskById = new Map(tasks.map((t) => [t.id, t]));
  const links: Array<{ from: ITask; to: ITask; status: ITask['status'] }> = [];

  tasks.forEach((task) => {
    if (!task.dependsOn) return;
    task.dependsOn.forEach((parentId) => {
      const parent = taskById.get(parentId);
      if (!parent) return;
      links.push({ from: parent, to: task, status: task.status });
    });
  });

  return (
    <svg
      width="100%"
      height="100%"
      style={{ position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'visible' }}
    >
      {links.map(({ from, to, status }, i) => {
        const x1 = from.position.x + NODE_W / 2;
        const y1 = from.position.y + NODE_H;
        const x2 = to.position.x + NODE_W / 2;
        const y2 = to.position.y;
        const midY = (y1 + y2) / 2;
        const path = `M ${x1} ${y1} C ${x1} ${midY}, ${x2} ${midY}, ${x2} ${y2}`;
        const isHighlighted = visibleIds.has(from.id) && visibleIds.has(to.id);
        return (
          <g key={`${from.id}-${to.id}-${i}`} opacity={isHighlighted ? 1 : 0.15}>
            <path
              d={path}
              fill="none"
              stroke={STROKE[status]}
              strokeWidth="1.25"
              strokeLinecap="round"
            />
            <circle cx={x2} cy={y2} r="2.5" fill={DOT[status]} />
          </g>
        );
      })}
    </svg>
  );
};
